import React, {useState, useEffect} from 'react';

import type {SelectComponentValue} from 'nutshell-core/types';

// @ts-expect-error - imported from .js/.jsx file

import {StateSelect} from 'shells/select/state-select';
import {TextFieldDebounced} from 'shells/textfield/textfield-debounced';

import type {LocationFormValue} from './types';

import styles from './location-default.module.css';

type Props = {
    value?: LocationFormValue;
    onChange: (formValue: {[field: string]: LocationFormValue}) => void;
    name: string;
    useProspectorStateSelector?: boolean;
};

const DEFAULT_FORM_VALUES = {
    country: 'US',
    state: '',
    city: '',
} as const;

export const FormLocationSelectWithinUS = ({
    value,
    onChange,
    name,
    useProspectorStateSelector,
}: Props) => {
    const [formData, setFormData] = useState(
        value && value.data ? value.data : DEFAULT_FORM_VALUES
    );

    useEffect(() => {
        // @ts-expect-error
        onChange({
            [name]: {
                selected: 'exactMatch',
                data: formData,
            },
        });
    }, [formData, name, onChange]);

    const handleStateSelectChange = (stateSelectObject: SelectComponentValue) => {
        // @ts-expect-error
        setFormData((prevData) => ({
            ...prevData,
            state: stateSelectObject.id,
        }));
    };

    const handleTextSelectChange = (textSelectValue: string) => {
        // @ts-expect-error
        setFormData((prevData) => ({
            ...prevData,
            city: textSelectValue,
        }));
    };

    return (
        <div className={styles.container}>
            <div style={{paddingTop: '12px'}} className={styles['exact-match-container']}>
                <StateSelect
                    value={formData.state}
                    country='US'
                    onChange={handleStateSelectChange}
                    useProspectorStateSelector={useProspectorStateSelector}
                />
                {formData.state && (
                    <TextFieldDebounced
                        // @ts-expect-error
                        className='ui-input--full-width'
                        placeholder='Enter a city…'
                        value={formData.city}
                        onChange={handleTextSelectChange}
                    />
                )}
            </div>
        </div>
    );
};
